<template>
  <div>
    <el-dialog title="分组"
               :visible.sync="dialogFormVisible"
               width="800px"
               top="30px"
               :close-on-click-modal="false"
               @close="emitClose()"
               @open="open()">
      <el-table :data="result"
                border
                style="width: 100%">
        <el-table-column type="index"
                         label="序号"
                         width="90"
                         align="center">
        </el-table-column>

        <el-table-column prop="name"
                         width="120"
                         label="分组名"
                         align="center"
                         show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="创建时间"
                         align="center"
                         width="200"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{
                scope.row.create_time
                  ? $moment(scope.row.create_time).format("YYYY-MM-DD HH:mm")
                  : ""
              }}
          </template>
        </el-table-column>
        <el-table-column label="修改时间"
                         align="center"
                         width="200"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{
                scope.row.update_time
                  ? $moment(scope.row.update_time).format("YYYY-MM-DD HH:mm")
                  : ""
              }}
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         align="center"
                         fixed="right">
          <template slot-scope="scope">
            <el-link type="primary"
                     :underline="false"
                     @click="goEdit(scope.row)"
                     style="marginRight:10px">编辑</el-link>
            <el-link type="danger"
                     @click="goDelte(scope.row)"
                     :underline="false">删除</el-link>
          </template>
        </el-table-column>

      </el-table>
      <div class="tableFooter"><el-button type="primary"
                   plain
                   @click="handleCreate()">新建</el-button>

        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>

    </el-dialog>

    <el-dialog :title="groupRitle"
               :visible.sync="dialogroupVisible"
               width="400px"
               top="30px"
               :close-on-click-modal="false"
               @close="groupClose()"
               @open="groupOpen()">
      <el-form>
        <el-form-item label="分组名称"><el-input v-model="groupName"
                    placeholder="请输入分组名称"
                    style="width:290px"></el-input></el-form-item>
      </el-form>
      <div class="footer">
        <div class="cancle"
             @click="groupClose()">取消</div>
        <div class="confirm"
             @click="handleSubmit()">确定</div>
      </div>

    </el-dialog>
  </div>
</template>
<script >
import {
  categoryList,
  CreatCategory,
  PutCategory,
  DeleteCategory,
} from '@/api/note'
export default {
  props: {
    visible: {
      type: Boolean,
      default: () => {
        return false
      },
    },
  },
  watch: {
    visible(val) {
      this.dialogFormVisible = val
    },
  },
  data() {
    return {
      groupRitle: '新建分组',
      dialogFormVisible: false,
      dialogroupVisible: false,
      result: [],
      query: {
        pageIndex: 1,
        pageSize: 10,
      },
      groupName: '',
      pageTotal: 0,
      rowId: null,
    }
  },
  methods: {
    open() {
      this.getCategoryList()
    },
    groupOpen() {},
    groupClose() {
      this.dialogroupVisible = false
      this.groupRitle = ''
    },
    emitClose() {
      this.$emit('close')
    },
    getCategoryList() {
      categoryList(this.query).then((res) => {
        this.result = res.list
        this.pageTotal = res.count
        console.log('result', this.result)
      })
    },
    handleCreate() {
      this.dialogroupVisible = true
    },
    goEdit(row) {
      this.groupRitle = '编辑分组'
      this.rowId = row.id
      this.groupName = row.name
      this.dialogroupVisible = true
    },
    goDelte(row) {
      let data = {
        ids: [],
      }
      data.ids.push(row.id)
      this.$confirm('确定要删除这条信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        DeleteCategory(data).then((res) => {
          this.getCategoryList()
          this.$message.success('删除成功!')
        })
      })
    },
    handleSubmit() {
      if (this.groupName == '') {
        this.$message.error('请输入内容!')
        return
      }
      if (this.groupRitle == '新建分组') {
        let data = {
          arr_data: [],
        }
        data.arr_data.push({
          name: this.groupName,
        })
        CreatCategory(data).then((res) => {
          this.dialogroupVisible = false
          this.getCategoryList()
          this.$message.success('创建成功!')
        })
      } else {
        let editData = {
          id: this.rowId,
          name: this.groupName,
        }
        PutCategory(editData).then((res) => {
          this.dialogroupVisible = false
          this.getCategoryList()
          this.$message.success('修改成功!')
        })
      }
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.getCategoryList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.getCategoryList()
    },
  },
}
</script>
<style lang="less" scoped>
::v-deep .el-dialog__header {
  background: #ebeef5;
}
.footer {
  display: flex;
  justify-content: flex-end;
  .cancle {
    text-align: center;
    width: 56px;
    height: 32px;
    line-height: 32px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #cccccc;
    margin-right: 10px;
  }
  .confirm {
    text-align: center;
    width: 56px;
    height: 32px;
    color: #fff;
    line-height: 32px;
    background: #409eff;
    border-radius: 4px 4px 4px 4px;
  }
}
.tableFooter {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
</style>